import { Pipe, PipeTransform } from '@angular/core';
import { sanitize } from '../../ph-bhp-ui.service';
@Pipe({
  name: 'labelSanitizer'
})
export class PhBhpLabelSanitizerPipe implements PipeTransform {
  transform(value: any, args: any[]): any {
    if(!value) return '';
    return sanitize(value);
  }
}